import React from "react"
import styled from "styled-components"
import {get} from "lodash"

import {getErrorMessage} from "@irati/utils/lang/formatError"
import {FormattedMessage} from "@irati/utils/lang"
import {error as errorColor} from "../global/colors"

const StyledUl = styled.ul`
  color: ${errorColor};
`

interface PasswordErrorResponse {
  lengthCheck: boolean,
  hasUppercase: boolean,
  hasLowercase: boolean,
  hasNumber: boolean,
  scoreCheck: boolean,
  minLength: number
}

interface Props {
  error: PBError
}

const SetPasswordError = ({error}: Props) => {
  const data: PasswordErrorResponse = get(error, "response.data.data", {})
  const errorMessage = getErrorMessage(error)
  const {lengthCheck, hasUppercase, hasLowercase, hasNumber, scoreCheck, minLength} = data

  return (
    <StyledUl>
      {errorMessage && (
        <li>
          <FormattedMessage id={errorMessage} />
        </li>
      )}
      {lengthCheck === false && (
        <li>
          <FormattedMessage id="errors.setPassword.lengthCheck" values={{length: minLength}} />
        </li>
      )}
      {hasUppercase === false && (
        <li>
          <FormattedMessage id="errors.setPassword.hasUppercase" />
        </li>
      )}
      {hasLowercase === false && (
        <li>
          <FormattedMessage id="errors.setPassword.hasLowercase" />
        </li>
      )}
      {hasNumber === false && (
        <li>
          <FormattedMessage id="errors.setPassword.hasNumber" />
        </li>
      )}
      {scoreCheck === false && (
        <li>
          <FormattedMessage id="errors.setPassword.scoreCheck" />
        </li>
      )}
    </StyledUl>
  )
}

export default SetPasswordError
